/** Canonical money display — NEVER rounds away cents (Tom 2026-07-24: "it
 * shouldnt round numbers anywhere in the app or in the partner access ever").
 * Whole dollars stay clean ("$5,000"); fractional amounts always show 2
 * decimals ("$10,026.73", "$0.50"). Every feature's money formatter delegates
 * here so the rule can't drift per-page. */
export function moneyExact(n: number): string {
  return "$" + n.toLocaleString("en-US", {
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

/** Sign-aware variant for ledgers that print negatives as "-$1,234.56". */
export function moneyExactSigned(n: number): string {
  return n < 0 ? "-" + moneyExact(-n) : moneyExact(n);
}
